export const en = {
  common: {
    signIn: "Sign in",
    signOut: "Sign out",
    signUp: "Sign up",
    getStarted: "Get started",
    email: "Email",
    password: "Password",
    name: "Full name",
    submit: "Submit",
    cancel: "Cancel",
    continue: "Continue",
    back: "Back",
    next: "Next",
    loading: "Loading...",
    save: "Save",
    dashboard: "Dashboard",
    logout: "Log out",
    language: "Language",
    theme: "Theme",
  },
  nav: {
    features: "Features",
    pricing: "Pricing",
    about: "About",
    contact: "Contact",
    dashboard: "Dashboard",
  },
  landing: {
    kicker: "Digital Growth Operating System",
    heroTitle1: "Grow smarter.",
    heroTitle2: "Ship faster.",
    heroTitle3: "One platform.",
    heroSubtitle:
      "DAAM fuses a professional marketing team with an AI Growth Advisor into a single workspace, built for brands, creators, and agencies across Saudi Arabia and the GCC.",
    ctaPrimary: "Start free",
    ctaSecondary: "See it in action",
    trustedBy: "Trusted by ambitious teams",
    features: {
      title: "Every growth workflow, in one place",
      subtitle: "Stop juggling 12 tools. DAAM unifies planning, execution, reporting, and AI insights.",
      items: [
        { title: "AI Growth Advisor", desc: "Weekly priorities, tailored recommendations, and a growth score powered by 🤖 مساعد دعم الذكي." },
        { title: "Client & Team Workspaces", desc: "Real-time collaboration between clients and DAAM specialists — no more email threads." },
        { title: "Content Pipeline", desc: "Plan, approve, and ship content across every channel with a single approval flow." },
        { title: "Measurable KPIs", desc: "Track followers, engagement, and revenue attribution in premium dashboards." },
        { title: "Bilingual by design", desc: "Native English + Arabic (RTL) support for global brands and MENA-first teams." },
        { title: "Enterprise-grade", desc: "SSO-ready, JWT auth, role-based access control, and audit logs from day one." },
      ],
    },
    pricing: {
      title: "Simple, scalable pricing",
      subtitle: "6-month or annual plans. Cancel anytime. All prices in USD.",
      per6mo: "/ 6 months",
      perYear: "/ year",
      popular: "Most popular",
      cta: "Choose plan",
    },
    finalCta: {
      title: "Ready to run growth like an operating system?",
      subtitle: "Join the teams already scaling with DAAM.",
      cta: "Start free — no credit card",
    },
    footer: { rights: "All rights reserved" },
  },
  auth: {
    loginTitle: "Welcome back",
    loginSubtitle: "Sign in to your DAAM workspace.",
    registerTitle: "Create your workspace",
    registerSubtitle: "Start growing with DAAM in less than 60 seconds.",
    forgotTitle: "Reset your password",
    forgotSubtitle: "Enter your email and we'll send a reset link.",
    resetTitle: "Set a new password",
    resetSubtitle: "Choose a strong password you haven't used before.",
    forgotLink: "Forgot password?",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    devResetLink: "Dev reset link (email delivery not yet wired):",
  },
  onboarding: {
    title: "Set up your workspace",
    step1: "About your business",
    step2: "Goals & channels",
    step3: "Choose your plan",
    businessName: "Business name",
    industry: "Industry",
    description: "Short description",
    targetAudience: "Target audience",
    goals: "Primary growth goals",
    channels: "Active social channels",
    budget: "Monthly marketing budget (USD)",
    goalsPlaceholder: "e.g. Grow followers, Generate leads, Launch product",
    complete: "Finish setup",
    billing6mo: "6 months",
    billingYear: "Yearly (save 12%)",
  },
  dashboard: {
    client: {
      welcome: "Welcome back",
      score: "Growth score",
      weeklyPriorities: "This week's priorities",
      recommendations: "AI recommendations",
      nextMilestone: "Next 14-day milestone",
      kpis: "Followers & engagement (last 8 weeks)",
      subscription: "Your subscription",
      regenerate: "Regenerate plan",
      onboardCta: "Complete onboarding to unlock your AI Growth Plan.",
      onboardBtn: "Start onboarding",
    },
    team: {
      title: "Team workspace",
      subtitle: "Everything you're accountable for this sprint.",
      clients: "Active clients",
      tasks: "My tasks",
      projects: "Projects",
    },
    admin: {
      title: "Admin control room",
      users: "Users",
      clients: "Clients",
      teamMembers: "Team members",
      activeSubs: "Active subscriptions",
      mrr: "Est. MRR",
      recentUsers: "Recent users",
      subscriptions: "Subscriptions",
    },
  },
  notif: {
    title: "Notifications",
    empty: "You're all caught up.",
    markAll: "Mark all as read",
  },
};

export const ar = {
  common: {
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    signUp: "إنشاء حساب",
    getStarted: "ابدأ الآن",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    submit: "إرسال",
    cancel: "إلغاء",
    continue: "متابعة",
    back: "رجوع",
    next: "التالي",
    loading: "جاري التحميل...",
    save: "حفظ",
    dashboard: "لوحة التحكم",
    logout: "خروج",
    language: "اللغة",
    theme: "المظهر",
  },
  nav: {
    features: "المميزات",
    pricing: "الأسعار",
    about: "من نحن",
    contact: "تواصل معنا",
    dashboard: "لوحة التحكم",
  },
  landing: {
    kicker: "نظام تشغيل النمو الرقمي",
    heroTitle1: "نموّ أذكى.",
    heroTitle2: "إطلاق أسرع.",
    heroTitle3: "منصة واحدة.",
    heroSubtitle:
      "تجمع دعم بين فريق تسويق محترف ومستشار نمو مدعوم بالذكاء الاصطناعي في مساحة عمل واحدة، مصمّمة للعلامات التجارية وصنّاع المحتوى والوكالات في المملكة العربية السعودية ودول الخليج.",
    ctaPrimary: "ابدأ مجاناً",
    ctaSecondary: "شاهد المنصة",
    trustedBy: "يثق بنا فرق طموحة",
    features: {
      title: "كل تدفقات النمو في مكان واحد",
      subtitle: "توقّف عن التنقّل بين ١٢ أداة. تُوحّد دعم التخطيط والتنفيذ والتقارير ورؤى الذكاء الاصطناعي.",
      items: [
        { title: "مستشار نمو بالذكاء الاصطناعي", desc: "أولويات أسبوعية وتوصيات مخصّصة ومؤشر نمو مدعوم بـ 🤖 مساعد دعم الذكي." },
        { title: "مساحات العميل والفريق", desc: "تعاون فوري بين العملاء ومختصي دعم — لا مزيد من سلاسل البريد." },
        { title: "خط أنابيب المحتوى", desc: "خطّط، اعتمد، وأطلق المحتوى عبر كل قناة بتدفّق موافقة موحّد." },
        { title: "مؤشرات قابلة للقياس", desc: "تابع المتابعين والتفاعل ونسب التحويل في لوحات فاخرة." },
        { title: "ثنائية اللغة أصلاً", desc: "دعم أصلي للعربية (RTL) والإنجليزية للفرق العالمية." },
        { title: "بمستوى المؤسسات", desc: "توثيق JWT ووصول قائم على الأدوار وسجلات تدقيق منذ اليوم الأول." },
      ],
    },
    pricing: {
      title: "أسعار بسيطة وقابلة للتوسّع",
      subtitle: "اشتراك نصف سنوي أو سنوي. ألغِ في أي وقت. جميع الأسعار بالدولار.",
      per6mo: "/ ٦ أشهر",
      perYear: "/ سنة",
      popular: "الأكثر شيوعاً",
      cta: "اختر الخطة",
    },
    finalCta: {
      title: "جاهز لتشغيل النمو كنظام تشغيل؟",
      subtitle: "انضم إلى الفرق التي تنمو بالفعل مع دعم.",
      cta: "ابدأ مجاناً — بدون بطاقة",
    },
    footer: { rights: "جميع الحقوق محفوظة" },
  },
  auth: {
    loginTitle: "مرحباً بعودتك",
    loginSubtitle: "سجّل الدخول إلى مساحة عملك.",
    registerTitle: "أنشئ مساحة عملك",
    registerSubtitle: "ابدأ النمو مع دعم في أقل من ٦٠ ثانية.",
    forgotTitle: "استعادة كلمة المرور",
    forgotSubtitle: "أدخل بريدك وسنرسل لك رابط إعادة التعيين.",
    resetTitle: "اختر كلمة مرور جديدة",
    resetSubtitle: "اختر كلمة مرور قوية لم تستخدمها من قبل.",
    forgotLink: "نسيت كلمة المرور؟",
    noAccount: "ليس لديك حساب؟",
    haveAccount: "لديك حساب بالفعل؟",
    devResetLink: "رابط إعادة التعيين (للتطوير — البريد لم يُفعّل بعد):",
  },
  onboarding: {
    title: "إعداد مساحة عملك",
    step1: "عن نشاطك",
    step2: "الأهداف والقنوات",
    step3: "اختر خطتك",
    businessName: "اسم النشاط",
    industry: "المجال",
    description: "وصف قصير",
    targetAudience: "الجمهور المستهدف",
    goals: "أهداف النمو الأساسية",
    channels: "القنوات الاجتماعية النشطة",
    budget: "الميزانية الشهرية للتسويق (بالدولار)",
    goalsPlaceholder: "مثال: زيادة المتابعين، جذب العملاء، إطلاق منتج",
    complete: "إنهاء الإعداد",
    billing6mo: "٦ أشهر",
    billingYear: "سنوي (وفّر ١٢٪)",
  },
  dashboard: {
    client: {
      welcome: "مرحباً بعودتك",
      score: "مؤشر النمو",
      weeklyPriorities: "أولويات هذا الأسبوع",
      recommendations: "توصيات الذكاء الاصطناعي",
      nextMilestone: "الهدف خلال ١٤ يوماً",
      kpis: "المتابعون والتفاعل (آخر ٨ أسابيع)",
      subscription: "اشتراكك",
      regenerate: "إعادة توليد الخطة",
      onboardCta: "أكمل الإعداد لتفعيل خطة النمو الذكية.",
      onboardBtn: "ابدأ الإعداد",
    },
    team: {
      title: "مساحة الفريق",
      subtitle: "كل ما أنت مسؤول عنه هذا السبرنت.",
      clients: "العملاء النشطون",
      tasks: "مهامي",
      projects: "المشاريع",
    },
    admin: {
      title: "غرفة التحكم",
      users: "المستخدمون",
      clients: "العملاء",
      teamMembers: "أعضاء الفريق",
      activeSubs: "الاشتراكات النشطة",
      mrr: "الإيراد الشهري التقديري",
      recentUsers: "أحدث المستخدمين",
      subscriptions: "الاشتراكات",
    },
  },
  notif: {
    title: "الإشعارات",
    empty: "لا توجد إشعارات جديدة.",
    markAll: "تعليم الكل كمقروء",
  },
};

export const translations = { en, ar };
